import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MessageComponent } from 'src/app/popups/message/message.component';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { FileSaveService } from 'src/service/file-save.service';
import { GalleryManagementService } from 'src/service/gallery-management.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { FileUploadFor, FocusInputType, GalleryType, InteractionType, KeyValues10, LocalService, OtpType, PageKey, Status, TriggeredEvent, Wrappers10 } from 'src/service/local.service';

@Component({
  selector: 'app-receipt-files',
  templateUrl: './receipt-files.component.html',
  styleUrl: './receipt-files.component.scss'
})
export class ReceiptFilesComponent {
  OtpType = OtpType;
  GalleryType = GalleryType; FileUploadFor = FileUploadFor;
  lstSectionConfigKeys: string[] = ["gallery", "table"]; maxBodyHeight = 0;
  businessId: string = ''; ctryCode: string = ''; interactionType = 0;
  receiptId: string = ''; imageViewTypes: string[] = ['jpeg', 'png', 'jpg', 'gif'];

  wrapper: Wrappers10; isOpenFileUpload = true; editId: string = ''; isDeleteEnabled = false; isShowOtpPopup = false;
  htmlId: string = ''; elementIds: any;

  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private route: ActivatedRoute, private languageManagementService: LanguageManagementService, private configurationManagementService: ConfigurationManagementService, private galleryManagementService: GalleryManagementService, private modalService: NgbModal, private fileSaveService: FileSaveService, private router: Router) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      title: 'title_' + this.htmlId
    };
  }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = parseInt(routeParams.interactionType);
      this.businessId = routeParams.businessId;
      this.receiptId = routeParams.id;

      this.configurationManagementService.ensurePageActions(PageKey.ReceiptFiles);

      if (this.interactionType != InteractionType.User && (this.businessId == '' || this.businessId == '0')) {
        this.localService.redirectToSeller();
      } else {
        this.localService.saveUrl();
        this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId, false, this.interactionType == InteractionType.User ? routeParams.businessId : '');
        this.ctryCode = routeParams.ctryCode;
        this.businessId = routeParams.businessId ? routeParams.businessId : '';
        this.onInitiate();
      }
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onInitiate() {
    this.onLoad();
  }

  onLoad() {
    this.galleryManagementService.getReceiptFiles(this.businessId, this.receiptId).subscribe(result => {
      this.wrapper = result;
      this.localService.tokenNumber = result.content.key && result.content.key.length > 1 ? result.content.key : (this.localService.languageContent && this.localService.languageContent.gallery ? this.localService.languageContent.gallery.draft : 'Draft');
    });
  }

  ngOnDestroy(): void {
    this.localService.tokenNumber = '';
  }

  onAction(index: number, key?: string) {
    switch (index) {
      case 1: {
        const item: KeyValues10 = this.wrapper.items.find(x => x.key == key);
        if (item) {
          this.fileSaveService.DownloadFile(item.v6, item.v2 + '.' + item.v3, this.localService.languageContent.gallery.download_failed);
        }
      } break;
      case 2: {
        this.isShowOtpPopup = true;
      } break;
      case 3: {
        const item: KeyValues10 = this.wrapper.items.find(x => x.key == key);
        if (item) {
          if (this.imageViewTypes.includes(item.v3)) {
            this.localService.galleryViewUrl = [item.v6];
          } else {
            window.open(item.v6, '_blank');
          }
        }
      } break;
      case 4: {
        this.onDelete(key);
      } break;
      case 5: {
        const lastUrl = this.localService.lastUrl;
        this.localService.lastUrl = '';
        if (lastUrl && lastUrl.length > 0) {
          this.router.navigate([lastUrl]);
        } else {
          this.router.navigate(['/billings' + this.localService.basicParamsString, this.businessId]);
        }
      } break;
      case 6: {
        this.isOpenFileUpload = false;
        this.onLoad();
        setTimeout(() => {
          this.isOpenFileUpload = true;
        }, 100);
      } break;
      case 7: {
        let item: KeyValues10 = this.wrapper.items.find(x => x.key == key);
        if (item) {
          item.v7 = item.v1;
          this.editId = key;
          this.localService.onFocusNextInput(this.elementIds.title + '-' + key, FocusInputType.TextBox, true);
        }
      } break;
      case 8: {
        this.editId = '';
      } break;
      case 9: {
        this.onSaveTitle();
      } break;
    }
  }

  onSaveTitle() {
    let item: KeyValues10 = this.wrapper.items.find(x => x.key == this.editId);
    if (item) {
      this.galleryManagementService.saveGalleryTitle(this.editId, item.v7).subscribe(result => {
        this.localService.showInformationByStatus(result.status);
        if (result.status == Status.Success) {
          item.v1 = item.v7;
          this.editId = '';
        }
      });
    }
  }

  onGetText(index: number, key: string): number {
    const item: KeyValues10 = this.wrapper.content;
    let data = 0;
    if (item) {
      switch (index) {
        case 1: {
          data = parseFloat(item.v1);
        } break;
        case 2: {
          data = parseFloat(item.v2);
        } break;
      }
    }
    return data;
  }

  onDelete(key?: string) {
    const modalRef = this.modalService.open(MessageComponent);
    modalRef.componentInstance.IsConfirmationType = true;
    modalRef.componentInstance.message = this.localService.languageContent.gallery.del_imgs;
    modalRef.result.then((result) => {
      if (result.event == TriggeredEvent.Ok) {
        this.galleryManagementService.removeGallery(key ?? '', this.receiptId, this.businessId, GalleryType.ReceiptFile).subscribe(result => {
          this.onLoad();
        });
      }
    });
  }

  onVerifiedOtp(e: any) {
    this.isDeleteEnabled = true;
    this.isShowOtpPopup = false;
  }
}
